<template>
    <div class="document-signatures col-md-8 col-md-offset-2">
        <accordion :one-at-atime="true" type="info">
            <panel v-for="document in Object.values(documents)"
                :type="isSigned(document.id) ? 'success' : 'primary'"
                :key="document.id"
                :is-open="document.id === openDocument">
                    <strong slot="header">
                        {{ document.type.toUpperCase() }}

                        <span v-if="isSigned(document.id)" class='glyphicon glyphicon-ok pull-right'></span>
                    </strong>

                    <div class="document-signature__pdf">
                        <iframe :src="document.content" width="710px" height="600px"></iframe>
                    </div>
                    <signature-toggle :key="document.id" :signed="isSigned(document.id)" v-on:toggleDocument="toggleSignedForDocument" :document="document"></signature-toggle>
            </panel>
        </accordion>
        <input v-for="signedDocumentId in signedDocuments" type="hidden" name="signature[]" :value="signedDocumentId" v-bind:key="signedDocumentId" />
    </div>
</template>

<script>
import VueStrap from 'vue-strap';
export default {
    components: {
        accordion: VueStrap.accordion,
        panel: VueStrap.panel
    },
    name: 'DocumentSignatures',

    props: {
        documents: Object
    },

    methods: {
        isSigned: function(id) {
            return this.signedDocuments.includes(id);
        },
        toggleSignedForDocument: function(id) {
            if (this.isSigned(id)) {
                this.signedDocuments = this.signedDocuments.filter(
                    item => item !== id
                );
            } else {
                this.signedDocuments.push(id);
            }
            this.openDocument = null;

            // this setTimeout is a result of some brokenness with PDF.js
            setTimeout(() => {
                let otherDocuments = Object.values(this.documents).filter(
                    document => !this.signedDocuments.includes(document.id)
                );

                this.openDocument = otherDocuments.length
                    ? otherDocuments[0].id
                    : null;
            }, 500);
        }
    },

    data: function() {
        return {
            signedDocuments: [],
            openDocument: Object.values(this.documents)[0].id
        };
    }
};
</script>
